import { render, staticRenderFns } from "./CallLog.vue?vue&type=template&id=60d141fb&scoped=true&"
import script from "./CallLog.vue?vue&type=script&lang=js&"
export * from "./CallLog.vue?vue&type=script&lang=js&"
import style0 from "./CallLog.vue?vue&type=style&index=0&id=60d141fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d141fb",
  null
  
)

export default component.exports